import { useEffect } from "react";
import { HelmetProvider } from "react-helmet-async";
import { Helmet } from "react-helmet";


const RefundPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);


  return (
    <>
      <HelmetProvider>
        <Helmet>
          <title>Refund Policy | Halo Holidays</title>
          <meta name="description" content="Understand our refund policy, including eligibility criteria, timelines, and steps to request a refund for your purchases or services." />
        </Helmet>
      </HelmetProvider>

      <div className="container mx-auto px-4 py-12">
        <h1 className="text-3xl font-semibold text-center">Refund Policy</h1>
        <hr className="mb-10 mt-5" />
        <p className="text-[1rem] text-gray-700 mb-8">
          If the supplier makes an insignificant change to your travel arrangements, we will make reasonable efforts to inform you as soon as reasonably possible if there is time before your departure, but we will have no liability to you. Examples of insignificant changes include alteration of your hotel by less than the specified cancellation date when booking the hotel, change of accommodation to another of the same or higher standard, or minor changes to services available at the hotel.
        </p>

        <p className="text-[1rem] mb-8 text-gray-700">
          Occasionally the supplier/principal may have to make a significant change to your confirmed travel arrangements. Examples of “significant changes” include the following, when made before departure.
        </p>
        <ul className="list-disc list-inside text-[1rem] text-halo-pink mb-8">
          <li><span className="text-gray-700">** A change of accommodation area for the whole or a significant part of your time away</span></li>
          <li><span className="text-gray-700">** A change of accommodation to that of a lower standard or classification for the whole or a significant part of your time away.</span></li>
          <li><span className="text-gray-700">** A change of accommodation to that of a lower standard or classification for the whole or a significant part of your time away.</span></li>
        </ul>


        <p className="text-[1rem] mb-8 text-gray-700">
        If the supplier/principal has to make a significant change or cancel your travel arrangements, we will tell you as soon as possible and if there is time to do so before departure, we will offer you the choice of:
        </p>
        <ul className="list-disc list-inside text-[1rem] text-halo-pink mb-8">
          <li><span className="text-gray-700">Accepting the changed travel arrangements; or</span></li>
          <li><span className="text-gray-700">Having a refund of all monies paid; or</span></li>
          <li><span className="text-gray-700">Accepting an offer of alternative travel arrangements of comparable or higher standard if available (at no extra cost); or</span></li>
          <li><span className="text-gray-700">If available, accepting an offer of alternative travel arrangements of a lower standard, with a refund of the price difference between the original travel arrangements and the alternative travel arrangements</span></li>
        </ul>


        <p className="text-[1rem] mb-8 text-gray-700">
        You must notify us of your choice as soon as possible and within the period of time that we give you for acceptance. If we do not hear from you within that time period, we will contact you again to request notification of your choice. If you fail to respond again we may treat the booking as terminated and refund your payment of the effected component.
        </p>


        <p className="text-[1rem] mb-8 text-gray-700">
        If you choose to cancel following notification of a significant change, we will provide a full refund of any travel insurance premiums paid to us if you are unable to transfer or reuse your policy.
        </p>


        <p className="text-[1rem] text-gray-700">
        <span className="text-halo-pink font-semibold">Force Majeure:</span> We will not pay you compensation if we have to cancel or change your travel arrangements in any way because of unusual or unforeseeable circumstances beyond our control. These can include, for example, war, riot, industrial dispute, terrorist activity and its consequences, natural or nuclear disaster, fire, adverse weather conditions, epidemics and pandemics, unavoidable technical problems with transport.
        </p>
      </div>
    </>
  );
};

export default RefundPolicy;
